import { Box, Button, ButtonGroup, Stack, Typography } from '@mui/material';
import { ControlModeAuthority } from '@src/types/ControlModes';
import { useState } from 'react';

export default function ControlModesList() {
  const [selectedAuthority, setSelectedAuthority] = useState('HMI');

  return (
    <main
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        padding: '1rem',
        width: '100%',
        height: '100%',
        overflowY: 'auto',
      }}
    >
      <header>
        <Typography variant='h5' component='h1'>
          Control Mode Configs
        </Typography>
      </header>
      <section
        style={{
          marginTop: '2rem',
        }}
      >
        <Stack
          direction='row'
          sx={{
            border: '1px solid #313D4F',
            background:
              'linear-gradient(90deg, #151C27 14%, #161C27 33.5%, #1A222E 86%)',
            p: 4,
            flex: 1,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexBasis: '50%',
              flex: 1,
              textAlign: 'left',
            }}
          >
            <Typography
              sx={{
                fontSize: '1.4rem',
                fontWeight: 600,
                '@media (min-width: 1536px)': {
                  fontSize: '1.7rem',
                },
              }}
            >
              AUTHORITY
            </Typography>
          </Box>
          <Box
            sx={{
              flexBasis: '50%',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <ButtonGroup>
              {Object.keys(ControlModeAuthority).map((key) => {
                if (!isNaN(Number(key))) {
                  return null;
                }
                return (
                  <Button
                    key={key}
                    size='medium'
                    variant={
                      selectedAuthority === key ? 'contained' : 'outlined'
                    }
                    color={selectedAuthority === key ? 'secondary' : 'inherit'}
                    onClick={() => {
                      setSelectedAuthority(key);
                    }}
                    sx={{
                      width: 150,
                      height: 57,
                      '@media (min-width: 1536px)': {
                        width: 300,
                        height: 80,
                        fontSize: '1.6rem',
                      },
                    }}
                  >
                    {key}
                  </Button>
                );
              })}
            </ButtonGroup>
          </Box>
        </Stack>
      </section>
      <section
        style={{
          marginTop: '2rem',
        }}
      >
        <Typography
          sx={{
            fontSize: '1.4rem',
            fontWeight: 600,
            textAlign: 'center',
          }}
        >
          No modes to display
        </Typography>
      </section>
    </main>
  );
}
